import { render } from "./editorjs.vue?vue&type=template&id=6911174a"
import script from "./editorjs.vue?vue&type=script&lang=js"
export * from "./editorjs.vue?vue&type=script&lang=js"

import "./editorjs.vue?vue&type=style&index=0&id=6911174a&lang=css"

import exportComponent from "E:\\PhpstormProjects\\cinnet_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__